export default "__VITE_ASSET__kl14Af2j__"